// extracted by mini-css-extract-plugin
export var buttons = "_1d-0";
export var buttonsActive = "_1d-h";
export var cancelConfirm = "_1d-1";
export var closeButton = "_1d-2";
export var column = "_1d-3";
export var container = "_1d-4";
export var detailHeader = "_1d-6";
export var detailTitle = "_1d-7";
export var detailsContent = "_1d-5";
export var header = "_1d-8";
export var headerWithClose = "_1d-9";
export var icon = "_1d-a";
export var infoIcon = "_1d-c";
export var informationContainer = "_1d-b";
export var sideDrawer = "_1d-d";
export var sideDrawerOpen = "_1d-e";
export var stickyFooter = "_1d-f";
export var typeOption = "_1d-g";